/* unplugin-vue-components disabled */
const __default__ = {
  props: {
  // you can use text prop instead of slot
    text: {
      type: String,
      default: undefined
    },
    lines: {
      type: Number,
      default: 1
    },
    tooltipPlacement: {
      type: String,
      default: undefined
    },
    teleported: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {
      show_tip: false
    }
  },
  methods: {
    onHover(){
      if (this.lines > 1) {
        this.show_tip = this.$el.offsetHeight < this.$el.scrollHeight
      }
      else {
        this.show_tip = this.$el.offsetWidth < this.$el.scrollWidth
      }
    },
    getSlotText() {
      if (!this.$slots.default) return
      return $utils.dom.getTextFromNodes(this.$slots.default())
    }
  }
}

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "c9be8efe-lines": (_ctx.lines)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__